const Contents = theme => {
  return {
    width: '100%',
    height: '100%',
    maxWidth: 1024,
    marginLeft: 'auto',
    marginRight: 'auto',
  }
}

export default Contents



// WEBPACK FOOTER //
// ./src/styles/mixins/contents.js